// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"55b5520f","66":"b61b2448","74":"9d2a0873","120":"01b74114","209":"feec8453","223":"7cb809e1","238":"3ebc7f8b","375":"2eb65d49","457":"6ce4bbdf","551":"45e9dfbe","672":"65896d3c","756":"1c6ae1af","795":"a4eaeccb","842":"7b7af38f","851":"85bb095e","963":"74b7a4ba"}[chunkId] + ".chunk.js";
};